Promise.all([
    import("url-helper"),
    import("deprecate/main"),
    import("bootstrap/js/dropdown"),
    import("auth-checker"),
    import("tap-side-menu/tap-side-menu"),
]).then(deps => {
    let [url] = deps;
});
